// This file is auto-generated by @hey-api/openapi-ts

import type { OptionsLegacyParser } from "@hey-api/client-axios";
import {
  queryOptions,
  type UseMutationOptions,
  infiniteQueryOptions,
  type InfiniteData,
} from "@tanstack/react-query";
import {
  client,
  dbHealth,
  runSqlQuery,
  getTableInfo,
  newMessage,
  newMessageStreaming,
  health,
  weaviateHealth,
  weaviateInfo,
  weaviateIndexes,
  weaviateIndexExist,
  weaviateCreateIndex,
  weaviateDeleteIndex,
  weaviateGetIndexCount,
  weaviateSearchIndex,
  weaviateUpsertIndex,
  getKpi,
  getSummary,
  getGrossProfitByPeriod,
  getGrossProfitPerRegion,
  getGrossProfitTrend,
  getSeasonalSalesProfit,
  getRevenuePerPeriod,
  getReclameCostPerPeriod,
  getSalesForecast,
  getShellKpis,
  runRegression,
  getFilterOptions,
  getPromptLibrary,
  createPrompt,
  getConversations,
  getEvents,
  getPreview,
  getDatasources,
  getDatasourceById,
  updateDatasource,
  createDatasource,
  usersCurrentUser,
  usersPatchCurrentUser,
  usersUser,
  usersPatchUser,
  usersDeleteUser,
  authJwtLogin,
  authJwtLogout,
  registerRegister,
  resetForgotPassword,
  resetResetPassword,
  verifyRequestToken,
  verifyVerify,
  getOrganizations,
  createOrganization,
  getOrganization,
  getOrganizationUsers,
  createUserForOrganization,
  getOrganizationDepartments,
  createDepartment,
  updateDepartment,
  removeUserFromOrganization,
  updateUserInOrganization,
  inviteUserToOrganizationByEmail,
  acceptInviteUserToOrganization,
  declineInviteUserToOrganization,
  getAirbusData,
  getAirbusGraphs,
} from "../sdk.gen";
import type {
  RunSqlQueryData,
  NewMessageData,
  NewMessageError,
  NewMessageResponse,
  NewMessageStreamingData,
  NewMessageStreamingError,
  NewMessageStreamingResponse,
  WeaviateHealthData,
  WeaviateInfoData,
  WeaviateIndexesData,
  WeaviateIndexExistData,
  WeaviateCreateIndexData,
  WeaviateCreateIndexError,
  WeaviateCreateIndexResponse,
  WeaviateDeleteIndexData,
  WeaviateDeleteIndexError,
  WeaviateDeleteIndexResponse,
  WeaviateGetIndexCountData,
  WeaviateSearchIndexData,
  WeaviateUpsertIndexData,
  WeaviateUpsertIndexError,
  WeaviateUpsertIndexResponse,
  GetKpiData,
  GetKpiError,
  GetKpiResponse,
  GetSummaryData,
  GetGrossProfitByPeriodData,
  GetGrossProfitByPeriodError,
  GetGrossProfitByPeriodResponse,
  GetGrossProfitPerRegionData,
  GetGrossProfitPerRegionError,
  GetGrossProfitPerRegionResponse,
  GetGrossProfitTrendData,
  GetGrossProfitTrendError,
  GetGrossProfitTrendResponse,
  GetSeasonalSalesProfitData,
  GetSeasonalSalesProfitError,
  GetSeasonalSalesProfitResponse,
  GetRevenuePerPeriodData,
  GetRevenuePerPeriodError,
  GetRevenuePerPeriodResponse,
  GetReclameCostPerPeriodData,
  GetReclameCostPerPeriodError,
  GetReclameCostPerPeriodResponse,
  GetSalesForecastData,
  GetSalesForecastError,
  GetSalesForecastResponse,
  GetShellKpisData,
  GetShellKpisError,
  GetShellKpisResponse,
  RunRegressionData,
  RunRegressionError,
  RunRegressionResponse,
  GetFilterOptionsData,
  CreatePromptData,
  CreatePromptError,
  CreatePromptResponse,
  GetEventsData,
  GetPreviewData,
  GetPreviewError,
  GetPreviewResponse,
  GetDatasourceByIdData,
  UpdateDatasourceData,
  UpdateDatasourceError,
  UpdateDatasourceResponse,
  CreateDatasourceData,
  CreateDatasourceError,
  CreateDatasourceResponse,
  UsersPatchCurrentUserData,
  UsersPatchCurrentUserError,
  UsersPatchCurrentUserResponse,
  UsersUserData,
  UsersPatchUserData,
  UsersPatchUserError,
  UsersPatchUserResponse,
  UsersDeleteUserData,
  UsersDeleteUserError,
  UsersDeleteUserResponse,
  AuthJwtLoginData,
  AuthJwtLoginError,
  AuthJwtLoginResponse,
  AuthJwtLogoutError,
  AuthJwtLogoutResponse,
  RegisterRegisterData,
  RegisterRegisterError,
  RegisterRegisterResponse,
  ResetForgotPasswordData,
  ResetForgotPasswordError,
  ResetForgotPasswordResponse,
  ResetResetPasswordData,
  ResetResetPasswordError,
  ResetResetPasswordResponse,
  VerifyRequestTokenError,
  VerifyRequestTokenResponse,
  VerifyVerifyData,
  VerifyVerifyError,
  VerifyVerifyResponse,
  CreateOrganizationData,
  CreateOrganizationError,
  CreateOrganizationResponse,
  GetOrganizationData,
  GetOrganizationUsersData,
  CreateUserForOrganizationData,
  CreateUserForOrganizationError,
  CreateUserForOrganizationResponse,
  GetOrganizationDepartmentsData,
  CreateDepartmentData,
  CreateDepartmentError,
  CreateDepartmentResponse,
  UpdateDepartmentData,
  UpdateDepartmentError,
  UpdateDepartmentResponse,
  RemoveUserFromOrganizationData,
  RemoveUserFromOrganizationError,
  RemoveUserFromOrganizationResponse,
  UpdateUserInOrganizationData,
  UpdateUserInOrganizationError,
  UpdateUserInOrganizationResponse,
  InviteUserToOrganizationByEmailData,
  InviteUserToOrganizationByEmailError,
  InviteUserToOrganizationByEmailResponse,
  AcceptInviteUserToOrganizationData,
  AcceptInviteUserToOrganizationError,
  AcceptInviteUserToOrganizationResponse,
  DeclineInviteUserToOrganizationData,
  DeclineInviteUserToOrganizationError,
  DeclineInviteUserToOrganizationResponse,
  GetAirbusDataData,
  GetAirbusDataError,
  GetAirbusDataResponse,
  GetAirbusGraphsData,
} from "../types.gen";
import type { AxiosError } from "axios";

type QueryKey<TOptions extends OptionsLegacyParser> = [
  Pick<TOptions, "baseURL" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
  },
];

const createQueryKey = <TOptions extends OptionsLegacyParser>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
): QueryKey<TOptions>[0] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseURL: (options?.client ?? client).getConfig().baseURL,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return params;
};

export const dbHealthQueryKey = (options?: OptionsLegacyParser) => [
  createQueryKey("dbHealth", options),
];

export const dbHealthOptions = (options?: OptionsLegacyParser) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dbHealth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: dbHealthQueryKey(options),
  });
};

export const runSqlQueryQueryKey = (
  options: OptionsLegacyParser<RunSqlQueryData>,
) => [createQueryKey("runSqlQuery", options)];

export const runSqlQueryOptions = (
  options: OptionsLegacyParser<RunSqlQueryData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await runSqlQuery({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: runSqlQueryQueryKey(options),
  });
};

export const getTableInfoQueryKey = (options?: OptionsLegacyParser) => [
  createQueryKey("getTableInfo", options),
];

export const getTableInfoOptions = (options?: OptionsLegacyParser) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTableInfo({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTableInfoQueryKey(options),
  });
};

export const newMessageQueryKey = (
  options: OptionsLegacyParser<NewMessageData>,
) => [createQueryKey("newMessage", options)];

export const newMessageOptions = (
  options: OptionsLegacyParser<NewMessageData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await newMessage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: newMessageQueryKey(options),
  });
};

export const newMessageMutation = (
  options?: Partial<OptionsLegacyParser<NewMessageData>>,
) => {
  const mutationOptions: UseMutationOptions<
    NewMessageResponse,
    AxiosError<NewMessageError>,
    OptionsLegacyParser<NewMessageData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await newMessage({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const newMessageStreamingQueryKey = (
  options: OptionsLegacyParser<NewMessageStreamingData>,
) => [createQueryKey("newMessageStreaming", options)];

export const newMessageStreamingOptions = (
  options: OptionsLegacyParser<NewMessageStreamingData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await newMessageStreaming({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: newMessageStreamingQueryKey(options),
  });
};

export const newMessageStreamingMutation = (
  options?: Partial<OptionsLegacyParser<NewMessageStreamingData>>,
) => {
  const mutationOptions: UseMutationOptions<
    NewMessageStreamingResponse,
    AxiosError<NewMessageStreamingError>,
    OptionsLegacyParser<NewMessageStreamingData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await newMessageStreaming({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const healthQueryKey = (options?: OptionsLegacyParser) => [
  createQueryKey("health", options),
];

export const healthOptions = (options?: OptionsLegacyParser) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await health({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: healthQueryKey(options),
  });
};

export const weaviateHealthQueryKey = (
  options: OptionsLegacyParser<WeaviateHealthData>,
) => [createQueryKey("weaviateHealth", options)];

export const weaviateHealthOptions = (
  options: OptionsLegacyParser<WeaviateHealthData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await weaviateHealth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: weaviateHealthQueryKey(options),
  });
};

export const weaviateInfoQueryKey = (
  options: OptionsLegacyParser<WeaviateInfoData>,
) => [createQueryKey("weaviateInfo", options)];

export const weaviateInfoOptions = (
  options: OptionsLegacyParser<WeaviateInfoData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await weaviateInfo({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: weaviateInfoQueryKey(options),
  });
};

export const weaviateIndexesQueryKey = (
  options: OptionsLegacyParser<WeaviateIndexesData>,
) => [createQueryKey("weaviateIndexes", options)];

export const weaviateIndexesOptions = (
  options: OptionsLegacyParser<WeaviateIndexesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await weaviateIndexes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: weaviateIndexesQueryKey(options),
  });
};

export const weaviateIndexExistQueryKey = (
  options: OptionsLegacyParser<WeaviateIndexExistData>,
) => [createQueryKey("weaviateIndexExist", options)];

export const weaviateIndexExistOptions = (
  options: OptionsLegacyParser<WeaviateIndexExistData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await weaviateIndexExist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: weaviateIndexExistQueryKey(options),
  });
};

export const weaviateCreateIndexQueryKey = (
  options: OptionsLegacyParser<WeaviateCreateIndexData>,
) => [createQueryKey("weaviateCreateIndex", options)];

export const weaviateCreateIndexOptions = (
  options: OptionsLegacyParser<WeaviateCreateIndexData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await weaviateCreateIndex({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: weaviateCreateIndexQueryKey(options),
  });
};

export const weaviateCreateIndexMutation = (
  options?: Partial<OptionsLegacyParser<WeaviateCreateIndexData>>,
) => {
  const mutationOptions: UseMutationOptions<
    WeaviateCreateIndexResponse,
    AxiosError<WeaviateCreateIndexError>,
    OptionsLegacyParser<WeaviateCreateIndexData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await weaviateCreateIndex({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const weaviateDeleteIndexMutation = (
  options?: Partial<OptionsLegacyParser<WeaviateDeleteIndexData>>,
) => {
  const mutationOptions: UseMutationOptions<
    WeaviateDeleteIndexResponse,
    AxiosError<WeaviateDeleteIndexError>,
    OptionsLegacyParser<WeaviateDeleteIndexData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await weaviateDeleteIndex({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const weaviateGetIndexCountQueryKey = (
  options: OptionsLegacyParser<WeaviateGetIndexCountData>,
) => [createQueryKey("weaviateGetIndexCount", options)];

export const weaviateGetIndexCountOptions = (
  options: OptionsLegacyParser<WeaviateGetIndexCountData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await weaviateGetIndexCount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: weaviateGetIndexCountQueryKey(options),
  });
};

export const weaviateSearchIndexQueryKey = (
  options: OptionsLegacyParser<WeaviateSearchIndexData>,
) => [createQueryKey("weaviateSearchIndex", options)];

export const weaviateSearchIndexOptions = (
  options: OptionsLegacyParser<WeaviateSearchIndexData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await weaviateSearchIndex({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: weaviateSearchIndexQueryKey(options),
  });
};

export const weaviateUpsertIndexQueryKey = (
  options: OptionsLegacyParser<WeaviateUpsertIndexData>,
) => [createQueryKey("weaviateUpsertIndex", options)];

export const weaviateUpsertIndexOptions = (
  options: OptionsLegacyParser<WeaviateUpsertIndexData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await weaviateUpsertIndex({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: weaviateUpsertIndexQueryKey(options),
  });
};

export const weaviateUpsertIndexMutation = (
  options?: Partial<OptionsLegacyParser<WeaviateUpsertIndexData>>,
) => {
  const mutationOptions: UseMutationOptions<
    WeaviateUpsertIndexResponse,
    AxiosError<WeaviateUpsertIndexError>,
    OptionsLegacyParser<WeaviateUpsertIndexData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await weaviateUpsertIndex({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getKpiQueryKey = (options: OptionsLegacyParser<GetKpiData>) => [
  createQueryKey("getKpi", options),
];

export const getKpiOptions = (options: OptionsLegacyParser<GetKpiData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getKpi({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getKpiQueryKey(options),
  });
};

export const getKpiMutation = (
  options?: Partial<OptionsLegacyParser<GetKpiData>>,
) => {
  const mutationOptions: UseMutationOptions<
    GetKpiResponse,
    AxiosError<GetKpiError>,
    OptionsLegacyParser<GetKpiData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getKpi({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSummaryQueryKey = (
  options: OptionsLegacyParser<GetSummaryData>,
) => [createQueryKey("getSummary", options)];

export const getSummaryOptions = (
  options: OptionsLegacyParser<GetSummaryData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSummaryQueryKey(options),
  });
};

export const getGrossProfitByPeriodQueryKey = (
  options: OptionsLegacyParser<GetGrossProfitByPeriodData>,
) => [createQueryKey("getGrossProfitByPeriod", options)];

export const getGrossProfitByPeriodOptions = (
  options: OptionsLegacyParser<GetGrossProfitByPeriodData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGrossProfitByPeriod({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGrossProfitByPeriodQueryKey(options),
  });
};

export const getGrossProfitByPeriodMutation = (
  options?: Partial<OptionsLegacyParser<GetGrossProfitByPeriodData>>,
) => {
  const mutationOptions: UseMutationOptions<
    GetGrossProfitByPeriodResponse,
    AxiosError<GetGrossProfitByPeriodError>,
    OptionsLegacyParser<GetGrossProfitByPeriodData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getGrossProfitByPeriod({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getGrossProfitPerRegionQueryKey = (
  options: OptionsLegacyParser<GetGrossProfitPerRegionData>,
) => [createQueryKey("getGrossProfitPerRegion", options)];

export const getGrossProfitPerRegionOptions = (
  options: OptionsLegacyParser<GetGrossProfitPerRegionData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGrossProfitPerRegion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGrossProfitPerRegionQueryKey(options),
  });
};

export const getGrossProfitPerRegionMutation = (
  options?: Partial<OptionsLegacyParser<GetGrossProfitPerRegionData>>,
) => {
  const mutationOptions: UseMutationOptions<
    GetGrossProfitPerRegionResponse,
    AxiosError<GetGrossProfitPerRegionError>,
    OptionsLegacyParser<GetGrossProfitPerRegionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getGrossProfitPerRegion({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getGrossProfitTrendQueryKey = (
  options: OptionsLegacyParser<GetGrossProfitTrendData>,
) => [createQueryKey("getGrossProfitTrend", options)];

export const getGrossProfitTrendOptions = (
  options: OptionsLegacyParser<GetGrossProfitTrendData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGrossProfitTrend({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGrossProfitTrendQueryKey(options),
  });
};

export const getGrossProfitTrendMutation = (
  options?: Partial<OptionsLegacyParser<GetGrossProfitTrendData>>,
) => {
  const mutationOptions: UseMutationOptions<
    GetGrossProfitTrendResponse,
    AxiosError<GetGrossProfitTrendError>,
    OptionsLegacyParser<GetGrossProfitTrendData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getGrossProfitTrend({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSeasonalSalesProfitQueryKey = (
  options: OptionsLegacyParser<GetSeasonalSalesProfitData>,
) => [createQueryKey("getSeasonalSalesProfit", options)];

export const getSeasonalSalesProfitOptions = (
  options: OptionsLegacyParser<GetSeasonalSalesProfitData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSeasonalSalesProfit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSeasonalSalesProfitQueryKey(options),
  });
};

export const getSeasonalSalesProfitMutation = (
  options?: Partial<OptionsLegacyParser<GetSeasonalSalesProfitData>>,
) => {
  const mutationOptions: UseMutationOptions<
    GetSeasonalSalesProfitResponse,
    AxiosError<GetSeasonalSalesProfitError>,
    OptionsLegacyParser<GetSeasonalSalesProfitData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getSeasonalSalesProfit({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getRevenuePerPeriodQueryKey = (
  options: OptionsLegacyParser<GetRevenuePerPeriodData>,
) => [createQueryKey("getRevenuePerPeriod", options)];

export const getRevenuePerPeriodOptions = (
  options: OptionsLegacyParser<GetRevenuePerPeriodData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRevenuePerPeriod({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRevenuePerPeriodQueryKey(options),
  });
};

export const getRevenuePerPeriodMutation = (
  options?: Partial<OptionsLegacyParser<GetRevenuePerPeriodData>>,
) => {
  const mutationOptions: UseMutationOptions<
    GetRevenuePerPeriodResponse,
    AxiosError<GetRevenuePerPeriodError>,
    OptionsLegacyParser<GetRevenuePerPeriodData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getRevenuePerPeriod({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getReclameCostPerPeriodQueryKey = (
  options: OptionsLegacyParser<GetReclameCostPerPeriodData>,
) => [createQueryKey("getReclameCostPerPeriod", options)];

export const getReclameCostPerPeriodOptions = (
  options: OptionsLegacyParser<GetReclameCostPerPeriodData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReclameCostPerPeriod({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReclameCostPerPeriodQueryKey(options),
  });
};

export const getReclameCostPerPeriodMutation = (
  options?: Partial<OptionsLegacyParser<GetReclameCostPerPeriodData>>,
) => {
  const mutationOptions: UseMutationOptions<
    GetReclameCostPerPeriodResponse,
    AxiosError<GetReclameCostPerPeriodError>,
    OptionsLegacyParser<GetReclameCostPerPeriodData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getReclameCostPerPeriod({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSalesForecastQueryKey = (
  options: OptionsLegacyParser<GetSalesForecastData>,
) => [createQueryKey("getSalesForecast", options)];

export const getSalesForecastOptions = (
  options: OptionsLegacyParser<GetSalesForecastData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSalesForecast({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSalesForecastQueryKey(options),
  });
};

export const getSalesForecastMutation = (
  options?: Partial<OptionsLegacyParser<GetSalesForecastData>>,
) => {
  const mutationOptions: UseMutationOptions<
    GetSalesForecastResponse,
    AxiosError<GetSalesForecastError>,
    OptionsLegacyParser<GetSalesForecastData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getSalesForecast({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getShellKpisQueryKey = (
  options: OptionsLegacyParser<GetShellKpisData>,
) => [createQueryKey("getShellKpis", options)];

export const getShellKpisOptions = (
  options: OptionsLegacyParser<GetShellKpisData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getShellKpis({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getShellKpisQueryKey(options),
  });
};

export const getShellKpisMutation = (
  options?: Partial<OptionsLegacyParser<GetShellKpisData>>,
) => {
  const mutationOptions: UseMutationOptions<
    GetShellKpisResponse,
    AxiosError<GetShellKpisError>,
    OptionsLegacyParser<GetShellKpisData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getShellKpis({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const runRegressionQueryKey = (
  options: OptionsLegacyParser<RunRegressionData>,
) => [createQueryKey("runRegression", options)];

export const runRegressionOptions = (
  options: OptionsLegacyParser<RunRegressionData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await runRegression({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: runRegressionQueryKey(options),
  });
};

export const runRegressionMutation = (
  options?: Partial<OptionsLegacyParser<RunRegressionData>>,
) => {
  const mutationOptions: UseMutationOptions<
    RunRegressionResponse,
    AxiosError<RunRegressionError>,
    OptionsLegacyParser<RunRegressionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await runRegression({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFilterOptionsQueryKey = (
  options: OptionsLegacyParser<GetFilterOptionsData>,
) => [createQueryKey("getFilterOptions", options)];

export const getFilterOptionsOptions = (
  options: OptionsLegacyParser<GetFilterOptionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFilterOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFilterOptionsQueryKey(options),
  });
};

export const getPromptLibraryQueryKey = (options?: OptionsLegacyParser) => [
  createQueryKey("getPromptLibrary", options),
];

export const getPromptLibraryOptions = (options?: OptionsLegacyParser) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPromptLibrary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPromptLibraryQueryKey(options),
  });
};

export const createPromptQueryKey = (
  options: OptionsLegacyParser<CreatePromptData>,
) => [createQueryKey("createPrompt", options)];

export const createPromptOptions = (
  options: OptionsLegacyParser<CreatePromptData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createPrompt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createPromptQueryKey(options),
  });
};

export const createPromptMutation = (
  options?: Partial<OptionsLegacyParser<CreatePromptData>>,
) => {
  const mutationOptions: UseMutationOptions<
    CreatePromptResponse,
    AxiosError<CreatePromptError>,
    OptionsLegacyParser<CreatePromptData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createPrompt({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getConversationsQueryKey = (options?: OptionsLegacyParser) => [
  createQueryKey("getConversations", options),
];

export const getConversationsOptions = (options?: OptionsLegacyParser) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getConversations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getConversationsQueryKey(options),
  });
};

export const getEventsQueryKey = (
  options: OptionsLegacyParser<GetEventsData>,
) => [createQueryKey("getEvents", options)];

export const getEventsOptions = (
  options: OptionsLegacyParser<GetEventsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEventsQueryKey(options),
  });
};

export const getPreviewQueryKey = (
  options: OptionsLegacyParser<GetPreviewData>,
) => [createQueryKey("getPreview", options)];

export const getPreviewOptions = (
  options: OptionsLegacyParser<GetPreviewData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPreview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPreviewQueryKey(options),
  });
};

export const getPreviewMutation = (
  options?: Partial<OptionsLegacyParser<GetPreviewData>>,
) => {
  const mutationOptions: UseMutationOptions<
    GetPreviewResponse,
    AxiosError<GetPreviewError>,
    OptionsLegacyParser<GetPreviewData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getPreview({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDatasourcesQueryKey = (options?: OptionsLegacyParser) => [
  createQueryKey("getDatasources", options),
];

export const getDatasourcesOptions = (options?: OptionsLegacyParser) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDatasources({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDatasourcesQueryKey(options),
  });
};

export const getDatasourceByIdQueryKey = (
  options: OptionsLegacyParser<GetDatasourceByIdData>,
) => [createQueryKey("getDatasourceById", options)];

export const getDatasourceByIdOptions = (
  options: OptionsLegacyParser<GetDatasourceByIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDatasourceById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDatasourceByIdQueryKey(options),
  });
};

export const updateDatasourceMutation = (
  options?: Partial<OptionsLegacyParser<UpdateDatasourceData>>,
) => {
  const mutationOptions: UseMutationOptions<
    UpdateDatasourceResponse,
    AxiosError<UpdateDatasourceError>,
    OptionsLegacyParser<UpdateDatasourceData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateDatasource({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const createDatasourceQueryKey = (
  options: OptionsLegacyParser<CreateDatasourceData>,
) => [createQueryKey("createDatasource", options)];

export const createDatasourceOptions = (
  options: OptionsLegacyParser<CreateDatasourceData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createDatasource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createDatasourceQueryKey(options),
  });
};

export const createDatasourceMutation = (
  options?: Partial<OptionsLegacyParser<CreateDatasourceData>>,
) => {
  const mutationOptions: UseMutationOptions<
    CreateDatasourceResponse,
    AxiosError<CreateDatasourceError>,
    OptionsLegacyParser<CreateDatasourceData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createDatasource({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const usersCurrentUserQueryKey = (options?: OptionsLegacyParser) => [
  createQueryKey("usersCurrentUser", options),
];

export const usersCurrentUserOptions = (options?: OptionsLegacyParser) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersCurrentUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usersCurrentUserQueryKey(options),
  });
};

export const usersPatchCurrentUserMutation = (
  options?: Partial<OptionsLegacyParser<UsersPatchCurrentUserData>>,
) => {
  const mutationOptions: UseMutationOptions<
    UsersPatchCurrentUserResponse,
    AxiosError<UsersPatchCurrentUserError>,
    OptionsLegacyParser<UsersPatchCurrentUserData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await usersPatchCurrentUser({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const usersUserQueryKey = (
  options: OptionsLegacyParser<UsersUserData>,
) => [createQueryKey("usersUser", options)];

export const usersUserOptions = (
  options: OptionsLegacyParser<UsersUserData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usersUserQueryKey(options),
  });
};

export const usersPatchUserMutation = (
  options?: Partial<OptionsLegacyParser<UsersPatchUserData>>,
) => {
  const mutationOptions: UseMutationOptions<
    UsersPatchUserResponse,
    AxiosError<UsersPatchUserError>,
    OptionsLegacyParser<UsersPatchUserData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await usersPatchUser({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const usersDeleteUserMutation = (
  options?: Partial<OptionsLegacyParser<UsersDeleteUserData>>,
) => {
  const mutationOptions: UseMutationOptions<
    UsersDeleteUserResponse,
    AxiosError<UsersDeleteUserError>,
    OptionsLegacyParser<UsersDeleteUserData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await usersDeleteUser({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authJwtLoginQueryKey = (
  options: OptionsLegacyParser<AuthJwtLoginData>,
) => [createQueryKey("authJwtLogin", options)];

export const authJwtLoginOptions = (
  options: OptionsLegacyParser<AuthJwtLoginData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authJwtLogin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: authJwtLoginQueryKey(options),
  });
};

export const authJwtLoginMutation = (
  options?: Partial<OptionsLegacyParser<AuthJwtLoginData>>,
) => {
  const mutationOptions: UseMutationOptions<
    AuthJwtLoginResponse,
    AxiosError<AuthJwtLoginError>,
    OptionsLegacyParser<AuthJwtLoginData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await authJwtLogin({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authJwtLogoutQueryKey = (options?: OptionsLegacyParser) => [
  createQueryKey("authJwtLogout", options),
];

export const authJwtLogoutOptions = (options?: OptionsLegacyParser) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authJwtLogout({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: authJwtLogoutQueryKey(options),
  });
};

export const authJwtLogoutMutation = (
  options?: Partial<OptionsLegacyParser>,
) => {
  const mutationOptions: UseMutationOptions<
    AuthJwtLogoutResponse,
    AxiosError<AuthJwtLogoutError>,
    OptionsLegacyParser
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await authJwtLogout({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const registerRegisterQueryKey = (
  options: OptionsLegacyParser<RegisterRegisterData>,
) => [createQueryKey("registerRegister", options)];

export const registerRegisterOptions = (
  options: OptionsLegacyParser<RegisterRegisterData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await registerRegister({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: registerRegisterQueryKey(options),
  });
};

export const registerRegisterMutation = (
  options?: Partial<OptionsLegacyParser<RegisterRegisterData>>,
) => {
  const mutationOptions: UseMutationOptions<
    RegisterRegisterResponse,
    AxiosError<RegisterRegisterError>,
    OptionsLegacyParser<RegisterRegisterData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await registerRegister({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const resetForgotPasswordQueryKey = (
  options: OptionsLegacyParser<ResetForgotPasswordData>,
) => [createQueryKey("resetForgotPassword", options)];

export const resetForgotPasswordOptions = (
  options: OptionsLegacyParser<ResetForgotPasswordData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await resetForgotPassword({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: resetForgotPasswordQueryKey(options),
  });
};

export const resetForgotPasswordMutation = (
  options?: Partial<OptionsLegacyParser<ResetForgotPasswordData>>,
) => {
  const mutationOptions: UseMutationOptions<
    ResetForgotPasswordResponse,
    AxiosError<ResetForgotPasswordError>,
    OptionsLegacyParser<ResetForgotPasswordData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await resetForgotPassword({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const resetResetPasswordQueryKey = (
  options: OptionsLegacyParser<ResetResetPasswordData>,
) => [createQueryKey("resetResetPassword", options)];

export const resetResetPasswordOptions = (
  options: OptionsLegacyParser<ResetResetPasswordData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await resetResetPassword({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: resetResetPasswordQueryKey(options),
  });
};

export const resetResetPasswordMutation = (
  options?: Partial<OptionsLegacyParser<ResetResetPasswordData>>,
) => {
  const mutationOptions: UseMutationOptions<
    ResetResetPasswordResponse,
    AxiosError<ResetResetPasswordError>,
    OptionsLegacyParser<ResetResetPasswordData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await resetResetPassword({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const verifyRequestTokenQueryKey = (options?: OptionsLegacyParser) => [
  createQueryKey("verifyRequestToken", options),
];

export const verifyRequestTokenOptions = (options?: OptionsLegacyParser) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await verifyRequestToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: verifyRequestTokenQueryKey(options),
  });
};

export const verifyRequestTokenMutation = (
  options?: Partial<OptionsLegacyParser>,
) => {
  const mutationOptions: UseMutationOptions<
    VerifyRequestTokenResponse,
    AxiosError<VerifyRequestTokenError>,
    OptionsLegacyParser
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await verifyRequestToken({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const verifyVerifyQueryKey = (
  options: OptionsLegacyParser<VerifyVerifyData>,
) => [createQueryKey("verifyVerify", options)];

export const verifyVerifyOptions = (
  options: OptionsLegacyParser<VerifyVerifyData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await verifyVerify({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: verifyVerifyQueryKey(options),
  });
};

export const verifyVerifyMutation = (
  options?: Partial<OptionsLegacyParser<VerifyVerifyData>>,
) => {
  const mutationOptions: UseMutationOptions<
    VerifyVerifyResponse,
    AxiosError<VerifyVerifyError>,
    OptionsLegacyParser<VerifyVerifyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await verifyVerify({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrganizationsQueryKey = (options?: OptionsLegacyParser) => [
  createQueryKey("getOrganizations", options),
];

export const getOrganizationsOptions = (options?: OptionsLegacyParser) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationsQueryKey(options),
  });
};

export const createOrganizationQueryKey = (
  options: OptionsLegacyParser<CreateOrganizationData>,
) => [createQueryKey("createOrganization", options)];

export const createOrganizationOptions = (
  options: OptionsLegacyParser<CreateOrganizationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createOrganization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createOrganizationQueryKey(options),
  });
};

export const createOrganizationMutation = (
  options?: Partial<OptionsLegacyParser<CreateOrganizationData>>,
) => {
  const mutationOptions: UseMutationOptions<
    CreateOrganizationResponse,
    AxiosError<CreateOrganizationError>,
    OptionsLegacyParser<CreateOrganizationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createOrganization({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrganizationQueryKey = (
  options: OptionsLegacyParser<GetOrganizationData>,
) => [createQueryKey("getOrganization", options)];

export const getOrganizationOptions = (
  options: OptionsLegacyParser<GetOrganizationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationQueryKey(options),
  });
};

export const getOrganizationUsersQueryKey = (
  options: OptionsLegacyParser<GetOrganizationUsersData>,
) => [createQueryKey("getOrganizationUsers", options)];

export const getOrganizationUsersOptions = (
  options: OptionsLegacyParser<GetOrganizationUsersData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationUsersQueryKey(options),
  });
};

export const createUserForOrganizationQueryKey = (
  options: OptionsLegacyParser<CreateUserForOrganizationData>,
) => [createQueryKey("createUserForOrganization", options)];

export const createUserForOrganizationOptions = (
  options: OptionsLegacyParser<CreateUserForOrganizationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createUserForOrganization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createUserForOrganizationQueryKey(options),
  });
};

export const createUserForOrganizationMutation = (
  options?: Partial<OptionsLegacyParser<CreateUserForOrganizationData>>,
) => {
  const mutationOptions: UseMutationOptions<
    CreateUserForOrganizationResponse,
    AxiosError<CreateUserForOrganizationError>,
    OptionsLegacyParser<CreateUserForOrganizationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createUserForOrganization({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrganizationDepartmentsQueryKey = (
  options: OptionsLegacyParser<GetOrganizationDepartmentsData>,
) => [createQueryKey("getOrganizationDepartments", options)];

export const getOrganizationDepartmentsOptions = (
  options: OptionsLegacyParser<GetOrganizationDepartmentsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationDepartments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationDepartmentsQueryKey(options),
  });
};

export const createDepartmentQueryKey = (
  options: OptionsLegacyParser<CreateDepartmentData>,
) => [createQueryKey("createDepartment", options)];

export const createDepartmentOptions = (
  options: OptionsLegacyParser<CreateDepartmentData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createDepartment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createDepartmentQueryKey(options),
  });
};

export const createDepartmentMutation = (
  options?: Partial<OptionsLegacyParser<CreateDepartmentData>>,
) => {
  const mutationOptions: UseMutationOptions<
    CreateDepartmentResponse,
    AxiosError<CreateDepartmentError>,
    OptionsLegacyParser<CreateDepartmentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createDepartment({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateDepartmentMutation = (
  options?: Partial<OptionsLegacyParser<UpdateDepartmentData>>,
) => {
  const mutationOptions: UseMutationOptions<
    UpdateDepartmentResponse,
    AxiosError<UpdateDepartmentError>,
    OptionsLegacyParser<UpdateDepartmentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateDepartment({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const removeUserFromOrganizationMutation = (
  options?: Partial<OptionsLegacyParser<RemoveUserFromOrganizationData>>,
) => {
  const mutationOptions: UseMutationOptions<
    RemoveUserFromOrganizationResponse,
    AxiosError<RemoveUserFromOrganizationError>,
    OptionsLegacyParser<RemoveUserFromOrganizationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await removeUserFromOrganization({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateUserInOrganizationMutation = (
  options?: Partial<OptionsLegacyParser<UpdateUserInOrganizationData>>,
) => {
  const mutationOptions: UseMutationOptions<
    UpdateUserInOrganizationResponse,
    AxiosError<UpdateUserInOrganizationError>,
    OptionsLegacyParser<UpdateUserInOrganizationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateUserInOrganization({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const inviteUserToOrganizationByEmailMutation = (
  options?: Partial<OptionsLegacyParser<InviteUserToOrganizationByEmailData>>,
) => {
  const mutationOptions: UseMutationOptions<
    InviteUserToOrganizationByEmailResponse,
    AxiosError<InviteUserToOrganizationByEmailError>,
    OptionsLegacyParser<InviteUserToOrganizationByEmailData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await inviteUserToOrganizationByEmail({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const acceptInviteUserToOrganizationQueryKey = (
  options: OptionsLegacyParser<AcceptInviteUserToOrganizationData>,
) => [createQueryKey("acceptInviteUserToOrganization", options)];

export const acceptInviteUserToOrganizationOptions = (
  options: OptionsLegacyParser<AcceptInviteUserToOrganizationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await acceptInviteUserToOrganization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: acceptInviteUserToOrganizationQueryKey(options),
  });
};

export const acceptInviteUserToOrganizationMutation = (
  options?: Partial<OptionsLegacyParser<AcceptInviteUserToOrganizationData>>,
) => {
  const mutationOptions: UseMutationOptions<
    AcceptInviteUserToOrganizationResponse,
    AxiosError<AcceptInviteUserToOrganizationError>,
    OptionsLegacyParser<AcceptInviteUserToOrganizationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await acceptInviteUserToOrganization({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const declineInviteUserToOrganizationQueryKey = (
  options: OptionsLegacyParser<DeclineInviteUserToOrganizationData>,
) => [createQueryKey("declineInviteUserToOrganization", options)];

export const declineInviteUserToOrganizationOptions = (
  options: OptionsLegacyParser<DeclineInviteUserToOrganizationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await declineInviteUserToOrganization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: declineInviteUserToOrganizationQueryKey(options),
  });
};

export const declineInviteUserToOrganizationMutation = (
  options?: Partial<OptionsLegacyParser<DeclineInviteUserToOrganizationData>>,
) => {
  const mutationOptions: UseMutationOptions<
    DeclineInviteUserToOrganizationResponse,
    AxiosError<DeclineInviteUserToOrganizationError>,
    OptionsLegacyParser<DeclineInviteUserToOrganizationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await declineInviteUserToOrganization({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAirbusDataQueryKey = (
  options?: OptionsLegacyParser<GetAirbusDataData>,
) => [createQueryKey("getAirbusData", options)];

export const getAirbusDataOptions = (
  options?: OptionsLegacyParser<GetAirbusDataData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAirbusData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAirbusDataQueryKey(options),
  });
};

const createInfiniteParams = <
  K extends Pick<
    QueryKey<OptionsLegacyParser>[0],
    "body" | "headers" | "path" | "query"
  >,
>(
  queryKey: QueryKey<OptionsLegacyParser>,
  page: K,
) => {
  const params = queryKey[0];
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...queryKey[0].path,
      ...page.path,
    };
  }
  if (page.query) {
    params.query = {
      ...queryKey[0].query,
      ...page.query,
    };
  }
  return params as unknown as typeof page;
};

export const getAirbusDataInfiniteQueryKey = (
  options?: OptionsLegacyParser<GetAirbusDataData>,
): QueryKey<OptionsLegacyParser<GetAirbusDataData>> => [
  createQueryKey("getAirbusData", options, true),
];

export const getAirbusDataInfiniteOptions = (
  options?: OptionsLegacyParser<GetAirbusDataData>,
) => {
  return infiniteQueryOptions<
    GetAirbusDataResponse,
    AxiosError<GetAirbusDataError>,
    InfiniteData<GetAirbusDataResponse>,
    QueryKey<OptionsLegacyParser<GetAirbusDataData>>,
    | number
    | Pick<
        QueryKey<OptionsLegacyParser<GetAirbusDataData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<OptionsLegacyParser<GetAirbusDataData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getAirbusData({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getAirbusDataInfiniteQueryKey(options),
    },
  );
};

export const getAirbusGraphsQueryKey = (
  options?: OptionsLegacyParser<GetAirbusGraphsData>,
) => [createQueryKey("getAirbusGraphs", options)];

export const getAirbusGraphsOptions = (
  options?: OptionsLegacyParser<GetAirbusGraphsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAirbusGraphs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAirbusGraphsQueryKey(options),
  });
};
